let API_BASE = "/api";

export class VideoSessionConstants {
  public static API_VIDEO_SESSIONS_SINGLE_MARK_NO_SHOW_EXPERT =
    API_BASE + "/video-sessions/{sessionId}/expert/no-show";

  public static API_VIDEO_SESSIONS_SINGLE_REVERT_NO_SHOW =
    API_BASE + "/video-sessions/{sessionId}/revert-no-show";

  public static API_VIDEO_SESSIONS_SINGLE_SCHEDULE_CANCEL =
    API_BASE + "/video-sessions/{sessionId}/cancel";
}
